/* eslint-disable camelcase */
/* eslint-disable indent */
import { Accordion, AccordionDetails, Button, Card, CardActions, CardContent, Divider, Grid, Icon, Stack, Tooltip, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import AgriAction from 'agriAdministration/actions/AgriAction'
import Input from 'components/forms/Input'
import ProgressCard from 'components/card/ProgressCard'
import { push } from '@lagunovsky/redux-react-router'
import IntervenantCard from 'exploitations/components/cards/IntervenantCard'
import InstallationAction from 'installation/actions/InstallationAction'
import { compact, groupBy, isEmpty, orderBy, uniqBy, isNil } from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ContactAction from 'referencial/components/contact/actions/ContactAction'
import UsageAction from 'referencial/components/usage/actions/UsageAction'
import i18n from 'simple-react-i18n'
import TankModal from 'station/components/link/modals/TankModal'
import DtoSamplingPointDecla from 'survey/dto/DtoSamplingPointDecla'
import DtoTankDeclaration from 'survey/dto/DtoTankDeclaration'
import ToastrAction from 'toastr/actions/ToastrAction'
import { whiteColor } from 'utils/constants/ColorTheme'
import { getDate } from 'utils/DateUtil'
import { hasValue } from 'utils/NumberUtil'
import { getLogin, getSetting } from 'utils/SettingUtils'
import { formatMilliers, getI18nTitleDataLength } from 'utils/StringUtil'
import CounterCard from './cards/CounterCard'
import OuvrageCard from './cards/OuvrageCard'
import PumpCard from './cards/PumpCard'
import RetenueCard from './cards/RetenueCard'
import ModalAddEquipements from './modals/ModalAddEquipements'
import ModalOuvrage from './modals/ModalOuvrage'
import ModalOwner from './modals/ModalOwner'
import ModalRemovePoint from './modals/ModalRemovePoint'
import { DECLARATION_STATUS, POINT_STATUS_DECLARATION, SITU_POINT_PUMP, SITU_PUMP_COUNTER, SURVEY_STATUS, USAGES_CATEGORY } from 'agriAdministration/constants/AgriConstants'
import { AccordionTitle } from 'components/styled/Accordions'
import { useParams } from 'react-router'
import useTitle from 'utils/customHook/useTitle'
import { CardTitle } from 'components/card/NewCard'
import { Check } from '@mui/icons-material'
import { NoDataPanel } from 'components/card/NoDataCard'

const ChronicleItem = styled(Grid)({
    padding: '4px !important',
    textAlign: 'center',
})

const TYPE_ESTIM = 1
const TYPE_INDEX = 2

const DeclarationPointDetails = ({}) => {
    const [openModalOuvrage, setOpenModalOuvrage] = useState(false)
    const [openModalOwner, setOpenModalOwner] = useState(false)
    const [openModalRetenue, setOpenModalRetenue] = useState(false)
    const [openModalEquipement, setOpenModalEquipement] = useState(false)
    const [retenueToUpdate, setRetenueToUpdate] = useState(false)
    const [openModalRemove, setOpenModalRemove] = useState(false)
    const [point, setPoint] = useState({})
    const [dataLoaded, setDataLoaded] = useState(false)

    const {
        usages,
        installation,
        declaration,
        exploitation,
        sandreCodes,
        contacts,
        declarationContributors,
        variousMateriels,
        survey,
        contributorsIndex,
        exploitationsExportFullData,
        accountUser,
    } = useSelector((store) => ({
        usages: store.UsageReducer.usages,
        installation: store.InstallationReducer.installation,
        declaration: store.AgriReducer.declaration,
        exploitation: store.AgriReducer.exploitation,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        contacts: store.ContactReducer.contacts,
        declarationContributors: store.AgriReducer.declarationContributors,
        variousMateriels: store.VariousMaterielReducer.variousMateriels,
        survey: store.AgriReducer.survey,
        contributorsIndex: store.ContributorReducer.contributorsIndex,
        exploitationsExportFullData: store.AgriReducer.exploitationsExportFullData,
        accountUser: store.HomeReducer.accountUser,
    }))

    const readMode = useMemo(() => survey?.statusCode === SURVEY_STATUS.ARCHIVED || declaration.statusCode >= DECLARATION_STATUS.VALIDATED || accountUser?.consultant === '1', [survey, declaration, accountUser])

    const dispatch = useDispatch()
    const params = useParams()

    const idInstallation = useMemo(() => parseInt(params.idPoint), [params])
    const linkPoint = useMemo(() => declaration.link_exploitationInstallation ? declaration.link_exploitationInstallation.find((p) => p.idInstallation === idInstallation) : {}, [declaration, idInstallation])
    const usagesCurrentYear = useMemo(() => point.link_usagesCurrent || [], [point])
    const usagesPrevi = useMemo(() => point.link_usages || [], [point])

    const formatContact = (contact, updatedContact) => {
        if (updatedContact) {
            return {
                ...contact,
                ...updatedContact,
                address: updatedContact.road,
                additionalAddress: updatedContact.addressComplement,
                desktopTel: updatedContact.fax,
                postalBox: updatedContact.postalCode,
            }
        }
        return contact
    }

    const owner = useMemo(() => {
        const ownerUpdated = declarationContributors.find((dc) => dc.link_installations.find((cI) => cI.idInstallation === installation.id && cI.surveyId === declaration.idSurvey))
        const id = ownerUpdated ? (ownerUpdated.idContributorTemp || ownerUpdated.idContributor || ownerUpdated.id) : installation.ownerCode
        const contact = ownerUpdated && ownerUpdated.idContributorTemp ? {} : (contacts.find((c) => c.id === id) || {})
        return formatContact(contact, ownerUpdated)
    }, [declarationContributors, contacts, installation, declaration])

    useTitle(() => ([
        {
            title: i18n.planning,
            href: 'planning',
        }, {
            title: i18n.surveys,
            href: 'planning/surveys',
        }, {
            title: `${survey.name || ''} [${survey.year || ''}]`,
            href: `survey/${survey.idSurvey}`,
        }, {
            title: `${i18n.declaration} ${exploitation.codification}`,
            href: `survey/${survey.idSurvey}/declaration/${declaration.idDeclaration}/stepper/0`,
        }, {
            title: `${i18n.pointPrelevement} ${installation.code}${installation.location ? ` - ${installation.location}` : ''}`,
            href: `survey/${survey.idSurvey}/declaration/${declaration.idDeclaration}/point/${idInstallation}`,
        },
    ]), [installation, declaration, exploitation, survey, params])

    const setContributors = (decla) => {
        const initPoint = decla ? decla.link_declarationInstallation.find(
                (p) => p.idInstallation === idInstallation,
            )
            : new DtoSamplingPointDecla({})
        setPoint(initPoint)
        setDataLoaded(true)
    }

    const getDeclaration = () => {
        setDataLoaded(false)
        dispatch(AgriAction.fetchDeclaration(params.idDeclaration)).then((res) => {
            if (isNil(res)) {
                dispatch(push('/'))
                return
            }
            dispatch(AgriAction.fetchDeclarationContributors(res.idSurvey)).then(() => {
                setContributors(res)
            })
        })
    }

    const getExploitation = () => {
        dispatch(InstallationAction.fetchInstallation(params.idPoint)).then(() => {
            if (!exploitation.idExploitation) {
                dispatch(AgriAction.fetchExploitationUser()).then(() => {
                    getDeclaration()
                })
            } else {
                getDeclaration()
            }
        })
    }

    useEffect(() => {
        dispatch(UsageAction.fetchUsages())
        if (!contacts.length) {
            dispatch(ContactAction.fetchContacts()).then(() => getExploitation())
        } else {
            getExploitation()
        }
    }, [])

    const onSaveEquipment = (link_equipments, link_pumps, link_counters) => {
        setDataLoaded(false)
        const link_declarationInstallation = [
            ...declaration.link_declarationInstallation.filter((p) => p.idInstallation !== idInstallation),
            {
                ...declaration.link_declarationInstallation.find((p) => p.idInstallation === idInstallation),
                link_equipments,
            },
        ]
        const newDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation,
            link_pumps,
            link_counters,
        }
        dispatch(AgriAction.updateDeclaration(newDeclaration, true)).then(() => {
            getDeclaration()
        })
        setOpenModalEquipement(false)
    }

    const getListUsages = (current) => {
        const usagesSelected = current ? usagesCurrentYear : usagesPrevi
        const agriUsages = []
        const nonAgriUsages = []
        usagesSelected.forEach((u) => {
            const usageCat = usages.find((uCat) => uCat.idUsage === u.idUsage)
            if (usageCat && usageCat.category === USAGES_CATEGORY.AGRI) {
                agriUsages.push(u)
            } else if (usageCat && usageCat.category !== USAGES_CATEGORY.AGRI) {
                nonAgriUsages.push(u)
            }
        })

        let totalAgri = 0
        if (agriUsages.length) {
            agriUsages.forEach((u) => {
                totalAgri = totalAgri + (isNaN(u.requestedYearVolume) ? 0 : u.requestedYearVolume)
            })
        }
        let totalNonAgri = 0
        if (nonAgriUsages.length) {
            nonAgriUsages.forEach((u) => {
                totalNonAgri = totalNonAgri + (isNaN(u.requestedYearVolume) ? 0 : u.requestedYearVolume)
            })
        }
        return (
            <Stack spacing={1}>
                <Input
                    title={i18n.agri}
                    value={`${agriUsages.length} ${agriUsages.length > 1 ? i18n.usages : i18n.usage} (${formatMilliers(totalAgri) || 0} m3)`}
                    readMode
                />
                <Input
                    title={i18n.nonAgri}
                    value={`${nonAgriUsages.length} ${nonAgriUsages.length > 1 ? i18n.usages : i18n.usage} (${formatMilliers(totalNonAgri) || 0} m3)`}
                    readMode
                />
            </Stack>
        )
    }

    const onValidePoint = () => {
        dispatch(push(`/survey/${declaration.idSurvey}/declaration/${declaration.idDeclaration}/stepper/3`))
    }

    const onSaveOwner = (ownerUpdated) => {
        const id = ownerUpdated.idContributorTemp || ownerUpdated.idContributor || ownerUpdated.id

        const newLink = {
            surveyId: declaration.idSurvey,
            idInstallation: installation.id,
            updateLogin: getLogin(),
        }

        const ownerFormatted = {
            ...ownerUpdated,
            road: ownerUpdated.address,
            addressComplement: ownerUpdated.additionalAddress,
            fax: ownerUpdated.desktopTel,
            postalCode: ownerUpdated.postalBox,
            idContributor: id,
            surveyId: declaration.idSurvey,
            contactType: 2,
        }
        // si on utilise un contact existant
        if (!isEmpty(ownerUpdated)) {
            if (id) {
                setDataLoaded(false)
                // si on change de propriétaire
                if ((ownerUpdated.idContributorTemp && owner.idContributorTemp && ownerUpdated.idContributorTemp !== owner.idContributorTemp) ||
                    (id !== (owner.idContributor || owner.id))) {
                    dispatch(AgriAction.updateDeclarationContributor(declaration.idSurvey, {
                        ...ownerFormatted,
                        link_installations: [
                            ...(ownerUpdated.link_installations || []),
                            {
                                ...newLink,
                                idContributor: id,
                                isTemp: !!ownerUpdated.idContributorTemp,
                            },
                        ],
                    })).then(() => {
                        getDeclaration()
                    })
                // si on modifie les infos du propriétaire actuel
                } else {
                    dispatch(AgriAction.updateDeclarationContributor(declaration.idSurvey, {
                        ...ownerFormatted,
                        link_installations: [
                            ...(ownerUpdated.link_installations || []),
                            {
                                ...newLink,
                                idContributor: id,
                                isTemp: !!ownerUpdated.idContributorTemp,
                            },
                        ],
                    })).then(() => {
                        getDeclaration()
                    })
                }
            } else if (!id) {
                setDataLoaded(false)
                dispatch(AgriAction.updateDeclarationContributor(declaration.idSurvey, ownerFormatted)).then((idReturned) => {
                    dispatch(AgriAction.updateDeclarationContributor(declaration.idSurvey, {
                        ...ownerFormatted,
                        idContributorTemp: idReturned,
                        link_installations: [
                            ...(ownerUpdated.link_installations || []),
                            {
                                ...newLink,
                                idContributor: idReturned,
                                isTemp: true,
                            },
                        ],
                    })).then(() => {
                        getDeclaration()
                    })
                })
            }
            setOpenModalOwner(false)
        } else {
            dispatch(ToastrAction.warning(i18n.fillOwner))
        }
    }

    const onDeclareUnused = () => {
        const points = declaration.link_declarationInstallation.filter(
            (p) => p.idInstallation !== idInstallation,
        )
        const newDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: points,
        }
        dispatch(AgriAction.updateDeclaration(newDeclaration)).then(() => {
            setOpenModalRemove(false)
            dispatch(push(`/survey/${declaration.idSurvey}/declaration/${declaration.idDeclaration}/stepper/3`))
        })
    }

    const onDeclareUsed = () => {
        const pointToRemove = declaration.link_declarationInstallation.find((p) => p.idInstallation === idInstallation)
        const points = [...declaration.link_declarationInstallation.filter(
            (p) => p.idInstallation !== idInstallation,
        ), {
            ...pointToRemove,
            stateCode: POINT_STATUS_DECLARATION.USED,
        }]
        const newDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: points,
        }
        dispatch(AgriAction.updateDeclaration(newDeclaration)).then(() => {
            setOpenModalRemove(false)
            dispatch(push(`/survey/${declaration.idSurvey}/declaration/${declaration.idDeclaration}/stepper/3`))
        })
    }

    const onDeclareAdjourn = () => {
        const pointToRemove = declaration.link_declarationInstallation.find((p) => p.idInstallation === idInstallation)
        const points = [...declaration.link_declarationInstallation.filter(
            (p) => p.idInstallation !== idInstallation,
        ), {
            ...pointToRemove,
            stateCode: POINT_STATUS_DECLARATION.ADJOURNED,
            link_usages: [],
        }]
        const newDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: points,
        }
        dispatch(AgriAction.updateDeclaration(newDeclaration)).then(() => {
            setOpenModalRemove(false)
            dispatch(push(`/survey/${declaration.idSurvey}/declaration/${declaration.idDeclaration}/stepper/3`))
        })
    }

    const onRemovePoint = () => {
        const pointToRemove = declaration.link_declarationInstallation.find((p) => p.idInstallation === idInstallation)
        const points = [...declaration.link_declarationInstallation.filter(
            (p) => p.idInstallation !== idInstallation,
        ), {
            ...pointToRemove,
            stateCode: POINT_STATUS_DECLARATION.REMOVED,
        }]
        const newDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: points,
        }
        dispatch(AgriAction.updateDeclaration(newDeclaration)).then(() => {
            setOpenModalRemove(false)
            dispatch(push(`/survey/${declaration.idSurvey}/declaration/${declaration.idDeclaration}/stepper/3`))
        })
    }

    const goToUsages = (type) => {
        dispatch(push(`/survey/${params.id}/declaration/${params.idDeclaration}/usages/${params.idPoint}/${type}`))
    }

    const getAssociatedResources = () => {
        return linkPoint ? linkPoint.link_samples[0] : null
    }

    const getTypePrel = (key) => {
        switch (key) {
            case 1:
                return 'PREL_AGRI.NATURE_PRELEVEMENT_ESO'
            case 2:
                return 'PREL_AGRI.NATURE_PRELEVEMENT_ESU'
            default:
                return 'PREL_AGRI.NATURE_PRELEVEMENT'
        }
    }

    const getNature = () => {
        const associatedResources = getAssociatedResources()
        if (associatedResources) {
            const codeType = getTypePrel(associatedResources.sampleType)
            const codeFind = sandreCodes.find((c) => c.field === codeType && c.code === associatedResources.sampleNature)
            return codeFind ? codeFind.name : ''
        }
        return ''
    }

    const onSaveOuvrage = (newOuvrage) => {
        const updatedDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: [
                ...declaration.link_declarationInstallation.filter((p) => p.idInstallation !== idInstallation),
                {
                    ...point,
                    link_sampleCasings: [{
                        ...newOuvrage,
                        idSurvey: declaration.idSurvey,
                        idExploitation: exploitation.idExploitation,
                        idInstallation,
                    }],
                },
            ],
        }
        dispatch(AgriAction.updateDeclaration(updatedDeclaration, true)).then(() => {
            getDeclaration()
            setOpenModalOuvrage(false)
        })
    }

    const getOuvrages = () => {
        if (linkPoint?.link_sampleCasings?.length) {
            return (
                linkPoint.link_sampleCasings.map((ouvrage) => {
                    const updatedOuvrage = point.link_sampleCasings.find((o) => o.idInstallation === ouvrage.idInstallation)
                    const ouvrageDecla = {
                        ...ouvrage,
                        ...updatedOuvrage,
                    }
                    return (
                        <Grid size={12} id={ouvrageDecla.id} key={ouvrageDecla.id}>
                            <OuvrageCard
                                title={i18n.work}
                                ouvrage={ouvrageDecla}
                                actions={readMode ? [] : [{ onClick: () => setOpenModalOuvrage(true), icon: 'edit', color: whiteColor }]}
                                round
                            />
                            {openModalOuvrage && (
                                <ModalOuvrage
                                    ouvrage={ouvrageDecla}
                                    open={openModalOuvrage}
                                    onCancel={() => setOpenModalOuvrage(false)}
                                    onValidate={onSaveOuvrage}
                                    surveyMode
                                />
                            )}
                        </Grid>
                    )
                })
            )
        }
        return (
            <Grid size={12}>
                <OuvrageCard
                    title={i18n.work}
                    round
                />
            </Grid>
        )
    }

    const getRetenues = () => {
        const length = linkPoint?.link_sampleTanks?.length || 0
        const title = getI18nTitleDataLength(`${i18n.detention} (${length} ${i18n.element})`, `${i18n.detentions} (${length} ${i18n.elements})`, length)
        return (
            <Accordion
                sx={{
                    border: '1px solid',
                    borderColor: 'primary.main',
                    borderRadius: 2,
                }}
            >
                <AccordionTitle title={title} />
                <AccordionDetails>
                    {length ? (
                        <Stack spacing={1}>
                            {linkPoint.link_sampleTanks.map((retenue) => {
                                const updatedRetenue = point.link_sampleTanks.find((o) => o.idTank === retenue.idTank)
                                const retenueDecla = updatedRetenue ? {
                                    ...retenue,
                                    ...new DtoTankDeclaration(updatedRetenue),
                                    link_periodes: updatedRetenue?.link_periodes?.length ? [...updatedRetenue?.link_periodes] : [...retenue.link_periodes],
                                } : retenue
                                return (
                                    <RetenueCard
                                        id={retenueDecla.idTank}
                                        key={retenueDecla.idTank}
                                        title={retenueDecla.id || i18n.noName}
                                        retenue={retenueDecla}
                                        actions={readMode ? [] :
                                            [{
                                                onClick: () => {
                                                    setRetenueToUpdate(retenueDecla)
                                                    setOpenModalRetenue(true)
                                                },
                                                icon: 'edit',
                                                color: whiteColor,
                                            }]
                                        }
                                    />
                                )
                            })}
                        </Stack>
                    ) : <NoDataPanel />}
                </AccordionDetails>
            </Accordion>
        )
    }

    const onCloseRetenue = () => {
        setRetenueToUpdate()
        setOpenModalRetenue(false)
    }

    const onSaveRetenue = (retenue) => {
        const updatedDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: [
                ...declaration.link_declarationInstallation.filter((p) => p.idInstallation !== idInstallation),
                {
                    ...point,
                    link_sampleTanks: [
                        ...point.link_sampleTanks.filter((t) => t.idTank !== retenue.idTank),
                        {
                            ...retenue,
                            idSurvey: declaration.idSurvey,
                            idExploitation: exploitation.idExploitation,
                            idInstallation,
                            link_periodes: (retenue.link_periodes || []).map((l) => ({
                                ...l,
                                idTank: retenue.idTank,
                                idSurvey: declaration.idSurvey,
                                updateLogin: getLogin(),
                            })),
                        }],
                },
            ],
        }
        dispatch(AgriAction.updateDeclaration(updatedDeclaration)).then(() => {
            getDeclaration()
            onCloseRetenue()
        })
    }

    const getExploitationEquipments = () => {
        const matsSituPoint = compact(declaration.link_exploitationMateriel.map((m) => {
            const matFound = variousMateriels.find((vM) => vM.id === m.idVarious && (!vM.administrator || (vM.administrator === declaration.idContributor) || vM.isShared))
            if (m.siteType === SITU_POINT_PUMP && m.siteCode === idInstallation && matFound) {
                return {
                    ...m,
                    shared: hasValue(matFound.administrator) && matFound.isShared,
                }
            }
            return null
        })) || []
        let matsSituOthers = []
        declaration.link_exploitationMateriel.forEach((m) => {
            const matFound = variousMateriels.find((vM) => vM.id === m.idVarious && (!vM.administrator || (vM.administrator === declaration.idContributor) || vM.isShared))
            if (!matsSituPoint.find((mP) => mP.idVarious === m.idVarious) &&
                !matsSituOthers.find((mO) => mO.idVarious === m.idVarious) &&
                m.siteType === SITU_POINT_PUMP &&
                declaration.link_exploitationInstallation.find((p) => m.siteCode === p.idInstallation) && matFound) {
                matsSituOthers.push({
                    ...m,
                    shared: hasValue(matFound.administrator) && matFound.isShared,
                })
            }
        })
        return uniqBy([...matsSituPoint, ...matsSituOthers], v => [v.idVarious, v.siteCode, v.siteCode, v.siteType, v.statusCode].join())
    }

    const getUpdatedMats = () => {
        const link_equipments = declaration.link_declarationInstallation.find((p) => p.idInstallation === idInstallation).link_equipments || []
        const materielsSelected = getExploitationEquipments().filter((m) => m.siteCode === idInstallation) // pompes installées initialement
        const newMats = link_equipments.filter((mLink) => !mLink.idMatAttachment && mLink.mode === 'c') // pompes ajoutées
        const deletedMats = link_equipments.filter((mLink) => !mLink.idMatAttachment && mLink.mode === 'd') // pompes supprimées

        const newSelectedMatsSitu = compact(newMats.map((mLink) => {
            return declaration.link_exploitationMateriel.find((mSitu) => mSitu.idVarious === mLink.idMat)
        }))
        const mergedSelectedMatSitu = compact([ // Pompes actuellement sur le point
            ...materielsSelected.filter((m) => !deletedMats.find((mLink) => m.idVarious === mLink.idMat)),
            ...newSelectedMatsSitu,
        ])

        const linkAssignments = link_equipments.filter((linkE) => linkE.assignmentRate)

        let linkCounters = link_equipments.filter((linkE) => linkE.idMatAttachment).map((linkE) => { // Liens entre pompes et compteurs
            return {
                idPump: linkE.idMat,
                idCounter: linkE.idMatAttachment,
                mode: linkE.mode,
            }
        })
        mergedSelectedMatSitu.forEach((mat) => {
            const counterSitu = declaration.link_exploitationMateriel.find((mSitu) => mSitu.siteType === SITU_PUMP_COUNTER && mat.idVarious === mSitu.siteCode)
            if (counterSitu && !linkCounters.find((linkC) => linkC.idPump === counterSitu.siteCode && linkC.idCounter === counterSitu.idVarious)) {
                linkCounters.push({
                    idPump: counterSitu.siteCode,
                    idCounter: counterSitu.idVarious,
                    mode: 'u',
                })
            }
        })
        return {
            mergedSelectedMatSitu: uniqBy(mergedSelectedMatSitu, v => [v.idVarious, v.siteCode, v.siteCode, v.siteType, v.statusCode].join()),
            linkAssignments,
            linkCounters,
        }
    }

    const getEquipments = () => {
        if (variousMateriels.length) {
            const { mergedSelectedMatSitu = [], linkAssignments = [], linkCounters = [] } = getUpdatedMats()
            const length = mergedSelectedMatSitu.length
            const title = getI18nTitleDataLength(`${i18n.materiel} (${length} ${i18n.element})`, `${i18n.materiels} (${length} ${i18n.elements})`, length)
            return (
                <Accordion
                    sx={{
                        border: '1px solid',
                        borderColor: 'primary.main',
                        borderRadius: 2,
                    }}
                >
                    <AccordionTitle
                        title={title}
                        actions={[
                            {
                                icon: 'edit',
                                onClick: (e) => {
                                    e.stopPropagation()
                                    setOpenModalEquipement(true)
                                },
                                color: whiteColor,
                                displayed: !readMode,
                            },
                        ]}
                    />
                    <AccordionDetails>
                        <Stack spacing={1}>
                            {mergedSelectedMatSitu.map((d) => {
                                const matPump = variousMateriels.find((m) => m.id === d.idVarious) || {}
                                const pump = matPump.pump || {}
                                const pumpAssignmentRate = linkAssignments.find((lA) => lA.idMat === d.idVarious && !lA.idMatAttachment)
                                const pumpRep = exploitation.link_repartition_materiels.find((m) => m.linkType === 1 && m.idElement1 === idInstallation && m.idElement2 === d.idVarious)
                                const pompeInfos = {
                                    ...declaration.link_exploitationMateriel.find((m) => m.siteType === SITU_PUMP_COUNTER && m.siteCode === d.idVarious),
                                    ...matPump,
                                    ...pump,
                                    ...declaration.link_pumps.find((p) => p.id === d.idVarious),
                                    assignmentRate: pumpAssignmentRate ? pumpAssignmentRate?.assignmentRate : pumpRep?.repartition,
                                    shared: hasValue(matPump.administrator) && matPump.isShared,
                                }
                                const allCompteursInfo = compact(linkCounters.filter((lC) => lC.idPump === d.idVarious && lC.mode !== 'd').map((lC) => {
                                    const matCounter = variousMateriels.find((c) => c.id === lC.idCounter)
                                    const counterAssignmentRate = linkAssignments.find((lA) => lA.idMat === d.idVarious && lA.idMatAttachment === lC.idCounter)
                                    const counterRep = exploitation.link_repartition_materiels.find((m) => m.linkType === 2 && m.idElement1 === d.idVarious && m.idElement2 === lC.idCounter)
                                    if (matCounter) {
                                        const counter = matCounter.counter || {}
                                        return {
                                            ...matCounter,
                                            ...counter,
                                            ...declaration.link_counters.find((c) => c.id === lC.idCounter),
                                            assignmentRate: counterAssignmentRate ? counterAssignmentRate?.assignmentRate : counterRep?.repartition,
                                            shared: hasValue(matCounter.administrator) && matCounter.isShared,
                                        }
                                    }
                                    return null
                                }))
                                return (
                                    <Grid key={matPump.id}>
                                        <PumpCard
                                            title={`${i18n.pumpingEquipment} ${pompeInfos.reference || ''}`}
                                            pump={pompeInfos}
                                            actions={pompeInfos.shared ?
                                                [{
                                                    icon: 'people',
                                                    tooltip: `${i18n.shared} (${i18n.administrator} : ${contributorsIndex[matPump.administrator]?.name})`,
                                                    color: whiteColor,
                                                }] : []}
                                        />
                                        {allCompteursInfo.map((counter) => (
                                            <CounterCard
                                                key={counter.id}
                                                title={`${i18n.countingDevice} ${counter.reference || ''}`}
                                                counter={counter}
                                                actions={counter.shared ?
                                                    [{
                                                        icon: 'people',
                                                        tooltip: `${i18n.shared} (${i18n.administrator} : ${contributorsIndex[counter.administrator]?.name})`,
                                                        color: whiteColor,
                                                    }] : []}
                                            />
                                        ))}
                                    </Grid>
                                )
                            })}
                        </Stack>
                    </AccordionDetails>
                </Accordion>
            )
        }
        return ''
    }

    const getMateriels = () => {
        const link_equipments = declaration.link_declarationInstallation.find((p) => p.idInstallation === idInstallation).link_equipments || []
        const newMats = link_equipments.filter((mLink) => !mLink.idMatAttachment && mLink.mode !== 'd')
        const deletedMats = link_equipments.filter((mLink) => !mLink.idMatAttachment && mLink.mode === 'd')
        const deletedCounters = link_equipments.filter((mLink) => mLink.idMatAttachment && mLink.mode === 'd')
        const exploitationPumps = declaration.link_exploitationMateriel.filter((m) => m.siteType === SITU_POINT_PUMP && m.siteCode === idInstallation && !deletedMats.find((mLink) => m.idVarious === mLink.idMat)) || []
        const mergedPumpsIds = uniqBy([
            ...exploitationPumps.map((m) => m.idVarious),
            ...newMats.map((m) => m.idMat),
        ], obj => obj)
        const exploitationCountersId = compact(mergedPumpsIds.flatMap((pumpId) => {
            const pumpSitu = declaration.link_exploitationMateriel.filter((situ) => situ.siteType === SITU_PUMP_COUNTER && situ.siteCode === pumpId && !deletedCounters.find((mLink) => pumpId === mLink.idMat))
            if (pumpSitu) {
                return pumpSitu.map((s) => s.idVarious)
            }
            return null
        }))
        const newCounters = link_equipments.filter((mLink) => mLink.idMatAttachment && mLink.mode !== 'd' && mergedPumpsIds.includes(mLink.idMat))
        const mergedCountersIds = uniqBy([
            ...exploitationCountersId,
            ...newCounters.map((m) => m.idMatAttachment),
        ], obj => obj)
        return [mergedPumpsIds, mergedCountersIds]
    }

    const getEvolValue = (type, chronicles, chronicle, index) => {
        if (type === TYPE_INDEX) {
            return chronicle.value - chronicles[index + 1].value
        }
        return Math.round(chronicles.slice(index).reduce((acc, d) => acc + d.value, 0))
    }

    const getChroniclesByType = (chroniclesByType, type, readingCoefficient = 1) => {
        if (chroniclesByType?.length) {
            const orderedChronicles = orderBy(chroniclesByType, ['measureDate', 'endDate', 'value'], ['desc', 'desc', 'desc'])
            return (
                <>
                    <ChronicleItem className='italic-label' size={3}>
                        {type === TYPE_ESTIM ? i18n.startDate : i18n.statementDate}
                    </ChronicleItem>
                    <ChronicleItem className='italic-label' size={3}>
                        {type === TYPE_ESTIM ? i18n.endDate : ''}
                    </ChronicleItem>
                    <ChronicleItem className='italic-label' size={3}>
                        {type === TYPE_ESTIM ? i18n.estimateM3 : i18n.index}
                    </ChronicleItem>
                    <ChronicleItem className='italic-label' size={3}>
                        {type === TYPE_ESTIM ? i18n.stack : i18n.evolution}
                    </ChronicleItem>
                    {compact(orderedChronicles.map((chronicle, i) => {
                        const valueEvol = i !== orderedChronicles.length - 1 ? getEvolValue(type, orderedChronicles, chronicle, i) : null
                        return (i > 4) ? null : (
                            <>
                                <ChronicleItem size={3}>
                                    {getDate(chronicle.measureDate)}
                                </ChronicleItem>
                                <ChronicleItem size={3}>
                                    {chronicle.endDate ? getDate(chronicle.endDate) : ''}
                                </ChronicleItem>
                                <ChronicleItem size={3}>
                                    {`${formatMilliers(chronicle.value) || 0}${chronicle.measureType === 1 ? ' m3' : ''}`}
                                </ChronicleItem>
                                <ChronicleItem size={3} style={ valueEvol < 0 ? { color: 'orange' } : {}}>
                                    {hasValue(valueEvol) ? ` ${valueEvol < 0 ? '-' : '+'} ${formatMilliers(Math.abs((valueEvol) * readingCoefficient))} m3` : ''}
                                </ChronicleItem>
                            </>
                        )
                    }))}
                    {orderedChronicles.length > 5 && <ChronicleItem size={11}>...</ChronicleItem>}
                    <ChronicleItem size={11}>
                        <Divider />
                    </ChronicleItem>
                </>
            )
        }
        return null
    }

    const getChronicles = () => {
        const [pumpsId, countersId] = getMateriels()
        const allIds = [...pumpsId, ...countersId]
        const groupedByMat = Object.values(groupBy(declaration.link_chronicles.filter((c) => allIds.includes(c.idMat) && (!linkPoint.startDate || c.measureDate >= linkPoint.startDate) && (!linkPoint.endDate || c.measureDate < linkPoint.endDate)), 'idMat'))
        return compact(groupedByMat.map((chronicles) => {
            const variousMat = variousMateriels.find((mat) => mat.id === chronicles[0].idMat) || {}
            const shared = hasValue(variousMat.administrator) && variousMat.isShared
            if (!hasValue(variousMat.administrator) || (variousMat.administrator === exploitation.operatorCode) || variousMat.isShared) {
                const indexChronicles = chronicles.filter((c) => c.measureType === TYPE_INDEX)
                const estimateChronicles = chronicles.filter((c) => c.measureType === TYPE_ESTIM)
                const counterUpdated = declaration.link_counters.find((c) => c.id === variousMat.id) || {}
                const readingCoefficient = counterUpdated.readingCoefficient || variousMat?.counter?.readingCoefficient
                return (
                    <Grid
                        size={12}
                        container
                        direction='row'
                        justifyContent='center'
                        key={variousMat.id}
                    >
                        <ChronicleItem size={11} className='bold' container alignItems='center'>
                            {variousMat.reference}{readingCoefficient ? ` - ${i18n.readingCoefficient} ${readingCoefficient}` : ''}
                            {variousMat?.counter?.informative && ` (${i18n.informative})`}
                            {shared && (
                                <Tooltip title={`${i18n.shared} (${i18n.administrator} : ${contributorsIndex[variousMat.administrator]?.name})`}>
                                    <Icon className='margin-left-1'>
                                        people
                                    </Icon>
                                </Tooltip>
                            )}
                        </ChronicleItem>
                        {getChroniclesByType(indexChronicles, TYPE_INDEX, readingCoefficient)}
                        {getChroniclesByType(estimateChronicles, TYPE_ESTIM)}
                    </Grid>
                )
            }
            return null
        }))
    }

    const getLineRepartition = (link) => {
        const exploitationFound = exploitationsExportFullData.find((e) => e.idExploitation === link.idExploitation) || {}
        return (
            <>
                <span>{exploitationFound.codification} : {hasValue(link.distribution) ? `${link.distribution} %` : i18n.unknown}</span><br />
            </>
        )
    }

    const link_shared = linkPoint ? linkPoint.link_shared || [] : []
    const pointIsShared = link_shared.filter((p) => p.idExploitation !== exploitation.idExploitation).length > 0
    const total = link_shared.reduce((acc, l) => acc + (l.distribution || 0), 0)
    const tooltip = (
        <>
            {link_shared.map((p) => getLineRepartition(p))}
            <span className='bold'>{i18n.total} : {`${total} %`}</span><br />
        </>
    )
    if (dataLoaded) {
        return (
            <Stack padding={1} sx={{ maxHeight: 'calc(100vh - 70px)', overflow: 'hidden' }} >
                <Card sx={{ maxHeight: '100%', overflow: 'hidden' }}>
                    <CardTitle
                        title={i18n.iCheckMySamplingPoint}
                    />
                    <CardContent sx={{ height: 'calc(100vh - 175px)', overflowY: 'auto' }}>
                        <Stack spacing={1}>
                            <Card>
                                <CardTitle title={i18n.description} />
                                <CardContent>
                                    <Stack direction={'row'} spacing={2} divider={<Divider orientation='vertical' flexItem />} >
                                        <Grid container>
                                            <Typography sx={{ fontWeight: 'bold' }}>{i18n.code}</Typography> : {installation.code}
                                            {pointIsShared && (
                                                <Tooltip title={tooltip}>
                                                    <Icon sx={{ marginLeft: '5px' }}>people</Icon>
                                                </Tooltip>
                                            )}
                                        </Grid>
                                        <Grid container>
                                            <Typography sx={{ fontWeight: 'bold' }}>{i18n.name}</Typography> : {installation.name}
                                        </Grid>
                                        <Grid container>
                                            <Typography sx={{ fontWeight: 'bold' }}>{i18n.sampleNature}</Typography> : {getNature()}
                                        </Grid>
                                        <Grid container>
                                            <Typography sx={{ fontWeight: 'bold' }}>{i18n.location}</Typography> : {installation.location}
                                        </Grid>
                                        <Grid container>
                                            <Typography sx={{ fontWeight: 'bold' }}>{i18n.descriptive}</Typography> : {installation.descriptive}
                                        </Grid>
                                        <Grid container>
                                            <Typography sx={{ fontWeight: 'bold' }}>{i18n.comment}</Typography> : {installation.comments}
                                        </Grid>
                                    </Stack>
                                </CardContent>
                            </Card>
                            <Grid container spacing={1}>
                                <Grid size={4} >
                                    <IntervenantCard
                                        title={i18n.owner}
                                        intervenant={owner}
                                        actions={readMode ?
                                            []
                                            :
                                            [
                                                {
                                                    icon: 'edit',
                                                    onClick: () => setOpenModalOwner(true),
                                                    color: 'white',
                                                },
                                            ]
                                        }
                                    />
                                </Grid>
                                <Grid size={4}>
                                    {getOuvrages()}
                                </Grid>
                                <Grid size={4} >
                                    <Card
                                        sx={{
                                            border: '1px solid',
                                            borderColor: 'primary.main',
                                            borderRadius: 2,
                                        }}
                                    >
                                        <CardTitle
                                            title={`${i18n.consos} ${survey.surveyType === 2 ? survey?.year : survey?.year - 1}`}
                                            color={'primary'}
                                            actions={[{
                                                icon: 'edit',
                                                onClick: () => goToUsages('reel'),
                                                color: whiteColor,
                                            }]}

                                        />
                                        <CardContent>
                                            {(getSetting(survey.link_params, 'usagesReal') || '1') !== '0' && getListUsages(true)}
                                            <Grid padding={1}>
                                                <Divider />
                                            </Grid>
                                            {(getSetting(survey.link_params, 'consos') || '1') !== '0' && getChronicles()}
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid size={4} >
                                    {getRetenues()}
                                </Grid>
                                <Grid size={4} >
                                    {getEquipments()}
                                </Grid>
                                <Grid size={4} >
                                    <Card
                                        sx={{
                                            border: '1px solid',
                                            borderColor: 'primary.main',
                                            borderRadius: 2,
                                        }}
                                    >
                                        <CardTitle
                                        title={`${i18n.anticipation} ${survey.year}`}
                                            color={'primary'}
                                            actions={[{
                                                icon: 'edit',
                                                onClick: () => goToUsages('previ'),
                                                color: whiteColor,
                                            }]}

                                        />
                                        <CardContent>
                                            {getListUsages(false)}
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Stack>
                    </CardContent>
                    <CardActions
                        sx={{
                            borderTop: '1px solid lightgrey',
                            justifyContent: 'center',
                        }}
                    >
                        <Grid>
                            <Button
                                variant='contained'
                                color='primary'
                                onClick={() => setOpenModalRemove(true)}
                                sx={{ width: '100%' }}
                                disabled={readMode}
                            >
                                {i18n.changeStatusPoint}
                            </Button>
                        </Grid>
                        <Grid>
                            <Button
                                variant='contained'
                                color='primary'
                                onClick={() => onValidePoint(declaration)}
                                sx={{ width: '100%' }}
                                endIcon={<Check />}
                            >
                                {i18n.validate}
                            </Button>
                        </Grid>
                    </CardActions>
                </Card>
                {openModalRemove && (
                    <ModalRemovePoint
                        open={openModalRemove}
                        onDeclareUsed={() => onDeclareUsed()}
                        onDeclareUnused={() => onDeclareUnused()}
                        onDeclareAdjourn={() => onDeclareAdjourn()}
                        onRemovePoint={() => onRemovePoint(declaration)}
                        onCancel={() => setOpenModalRemove(false)}
                        pointStatus={declaration.link_declarationInstallation.find((p) => p.idInstallation === idInstallation).stateCode}
                    />
                )}
                {openModalRetenue && (
                    <TankModal
                        tank={retenueToUpdate}
                        open={openModalRetenue}
                        onCancel={onCloseRetenue}
                        onValidate={onSaveRetenue}
                        lockId
                    />
                )}
                {openModalOwner && (
                    <ModalOwner
                        owner={owner || {}}
                        open={openModalOwner}
                        onCancel={() => setOpenModalOwner(false)}
                        onSave={onSaveOwner}
                    />
                )}
                {openModalEquipement && (
                    <ModalAddEquipements
                        open={openModalEquipement}
                        materiels={getExploitationEquipments().filter(({ shared }) => !shared)}
                        point={point}
                        declaration={declaration}
                        onSave={onSaveEquipment}
                        onCancel={() => setOpenModalEquipement(false)}
                    />
                )}
            </Stack>
        )
    }
    return <ProgressCard indeterminate round />
}

export default DeclarationPointDetails
